module.exports = __webpack_public_path__ + "static/standard1-0b9a73945b922a82495019b6b35f537f.png";